import buildUrl from 'url-join';


export const GRAPHQL_HOST = process.env.GRAPHQL_HOST;
export const GRAPHQL_BASEPATH = '/api/frontoffice/v1/graphql';
export const GRAPHQL_PUBLIC_BASEPATH = '/api/public/v1/graphql';
export const GRAPHQL_URL = buildUrl(GRAPHQL_HOST, GRAPHQL_BASEPATH);
